'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import emptyFunction from 'react-utils/emptyFunction';
export default function withContextMenuForm(WrappedComponent) {
  var _class, _temp;

  return _temp = _class = class HighOrderWithContextMenuForm extends PureComponent {
    constructor(...args) {
      super(...args);

      this.handleCallback = data => {
        this.props.callback(data);
        this.props.closeContextMenu();
      };
    }

    render() {
      return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, this.props, {
        callback: this.handleCallback
      }));
    }

  }, _class.propTypes = {
    callback: PropTypes.func.isRequired,
    closeContextMenu: PropTypes.func.isRequired
  }, _class.defaultProps = {
    closeContextMenu: emptyFunction
  }, _temp;
}